// Testi visibili delle chiamate vocali, tutti in un punto.
// BOZZA: da far approvare prima del rilascio.
import type { StartVoiceCallError } from "@shared/voice";

export type CallErrorCode = StartVoiceCallError | "mic_denied" | "mic_unavailable" | "offline" | "interrupted";

export const CALL_COPY = {
  callButton: "Chiama",
  ringing: "Sto chiamando…",
  connecting: "Connessione…",
  ended: "Chiamata terminata",
  networkWarning: "Connessione instabile…",
  mute: "Disattiva microfono",
  unmute: "Riattiva microfono",
  hangUp: "Riaggancia",
  close: "Chiudi",
  callMessage: "Chiamata vocale",
  errors: {
    mic_denied: "Per chiamare serve l'accesso al microfono. Abilitalo nelle impostazioni del browser e riprova.",
    mic_unavailable: "Non trovo un microfono su questo dispositivo.",
    minutes_exhausted: "Hai finito i minuti di chiamata di questo mese.",
    profile_not_callable: "Al momento non è possibile chiamare questo profilo.",
    voice_disabled: "Le chiamate non sono disponibili al momento.",
    provider_error: "Non è stato possibile avviare la chiamata. Riprova tra poco.",
    offline: "Sei offline. Controlla la connessione e riprova.",
    interrupted: "La chiamata si è interrotta.",
  } satisfies Record<CallErrorCode, string>,
};

export function formatCallDuration(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
